<ng-template #content let-modal>
  <div trapFocus>
    <div class="modal-header ml-auto align-items-center">
      <!-- <span class="modal-item">Cogito</span>
            <span class="modal-item">Ergo</span>
            <span class="modal-item">Action secondary</span>
            <span class="modal-item"><button type="button" class="btn btn-lg text-uppercase">Action</button></span> -->
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="modal.dismiss('Cross click')"
        ngbAutofocus
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body p-3 validate-lb" id="lightbox" style="height: 75vh">
      <div
        class="row"
        style="position: absolute; left: 10%; top: 10%; width: 80%"
      >
        <div class="col-12" *ngIf="!data.appeal">
          <div class="h2-eq">{{ texts?.intro }}</div>

          <table style="margin: 30px; width: 100%">
            <tr *ngFor="let slider of data.sliders">
              <td>{{ slider.caption }}</td>
              <td>{{ slider.value }}</td>
            </tr>
          </table>

          <div
            class="h2-eq"
            style="text-align: center; color: red; margin-top: 50px"
          >
            <button class="btn-validate text-uppercase" (click)="confirm()">
              {{ texts?.confirm }}
            </button>
            <button
              class="btn-validate text-uppercase"
              (click)="modal.dismiss('Cross click')"
            >
              {{ texts?.cancel }}
            </button>
          </div>
        </div>

        <div class="col-12" *ngIf="data.appeal">
          <div class="h2-eq">{{ getFormattedText() }}</div>

          <table style="margin: 30px; width: 100%">
            <tr *ngFor="let slider of data.sliders">
              <td>{{ slider.caption }}</td>
              <td>{{ slider.value }}</td>
            </tr>
          </table>

          <div
            style="font-weight: 600; font-size: 40px; text-align: center"
            [ngStyle]="{ color: rgbColor }"
          >
            {{ texts?.appeal }}: {{ data.appeal * 100 | number: "1.0-0" }}%
          </div>

          <div class="h2-eq" style="margin-top: 30px; margin-bottom: 30px">
            {{ texts?.explanation }}
          </div>

          <div
            class="h2-eq"
            style="text-align: center; color: red; margin-top: 50px"
          >
            <button
              class="btn-validate text-uppercase"
              (click)="modal.dismiss('Cross click')"
            >
              {{ texts?.close }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer text-uppercase"></div>
  </div>
</ng-template>
